<template>
  <div class="bankAccounts">
    <div class="row">
      <div class="col">
        <h1 class="fw-600 fs-24 mb-0">Adicionar Conta Bancária</h1>
      </div>
    </div>
    <hr>
    <FormBankAccounts :_bankAccount="bankAccount" @store="store" />
    <LoadingComponent :loading="loading" />
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import FormBankAccounts from './FormBankAccounts'
import LoadingComponent from '../../components/layout/LoadingComponent'

export default {

  name: 'CreateBankAccountsPage',

  components: {
    LoadingComponent,
    FormBankAccounts
  },

  data () {
    return {
      bankAccount: {
        param_bank_id: null,
        type: null
      }
    }
  },

  watch: {
    details () {
      this.bankAccount = {
        ...this.details
      }
    }
  },

  computed: mapState({
    details: state => state.bankAccounts.details,
    loading: state => state.bankAccounts.loading
  }),

  methods: {

    ...mapActions('bankAccounts', [
      'store'
    ])

  }

}

</script>
